export const SLIDER_STEP_SIZE = 0.005;
export const APP_NAME = "Colorfill";
export const APP_NAME_CAP = "COLORFILL";

export const MAX_LINE_WIDTH = 0.08;
export const MIN_LINE_WIDTH = 0.002;
export const LINE_SLIDER_MAX = 21;
export const LINE_SLIDER_MIN = 0;
